import { Select } from "antd";
import { ReactComponent as DropArrow } from '../../assets/images/drop_arrow.svg';

const CustomSingleDropdown = ({ forlabel, options, error,classNames, ...rest }) => {
    return (
        <div className="form_group mb_0">
            <div className="form_label">
                <label htmlFor="">{forlabel}</label>
            </div>
            <div className="form_input">
                <Select   placeholder={"Select from below"} suffixIcon={<DropArrow />} type="dropdown" {...rest} onChange={(e, data) => rest.onChange({ target: { value: e, name: rest.name, type: "dropdown" } }, data)} className={`form_control skill_multiselect ${classNames && classNames}` } >
                    {
                        options?.map(option => (
                            <option key={rest.name === 'course_name' ? option.courseId : option.id} value={option.name}>{option.name}</option>
                        ))
                    }
                </Select>
                <div className="errMsg">{error}</div>
            </div>
        </div>
    )
};

export default CustomSingleDropdown